import PropTypes from 'prop-types';
import { Box, Text } from '@qga/roo-ui/components';
import { CUSTOMER_SUPPORT_CALL_HOURS, CUSTOMER_SUPPORT_CALL_DAYS } from 'config/constants';

const ConfirmationInfo = ({ caseNumber, email, propertyName, ...styleProps }) => (
  <Box {...styleProps}>
    <Box mt={3} data-testid="request-reference-number">
      <Text fontSize="lg">Request reference number: {caseNumber}.</Text>
    </Box>
    <Box mt={[3, 4]} data-testid="request-confirmation-content">
      <Box>
        <Text fontSize="lg">
          You’ll receive an email to <strong>{email}</strong> from us shortly detailing your date change request.
        </Text>
      </Box>
      <Box mt={3}>
        <Text fontSize="lg">
          We’ll contact {propertyName} Hotel on your behalf to arrange the date change and then follow up with you to finalise your new
          booking dates.
        </Text>
      </Box>
      <Box mt={3}>
        <Text fontSize="lg">
          We’ll be in touch within the next 24 hours, between {CUSTOMER_SUPPORT_CALL_HOURS} ({CUSTOMER_SUPPORT_CALL_DAYS}).
        </Text>
      </Box>
    </Box>
  </Box>
);

ConfirmationInfo.propTypes = {
  caseNumber: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  propertyName: PropTypes.string.isRequired,
};

export default ConfirmationInfo;
